import { useCallback } from "react";

import { DEFAULT_ACTIVATION_WEB_SOURCE } from "app/pages/activation/routing/constants";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { ACTIVATION_ALERTS_ROUTE } from "../routes/constants";
import type { IAlertsRouteParams } from "../routes/routeParams";

import { useAlertsDefaultDuration } from "./useAlertsDefaultDuration";

type NavigateToAlertsParams = Omit<
    IAlertsRouteParams,
    "country" | "duration" | "tab" | "isDurationChanged" | "webSource"
> &
    Partial<Pick<IAlertsRouteParams, "duration" | "tab">> & {
        country: number | string;
    };

export const useAlertsPageNavigation = () => {
    const defaultDuration = useAlertsDefaultDuration();

    const navigateToAlerts = useCallback(
        ({ duration = defaultDuration, ...other }: NavigateToAlertsParams) =>
            proNavigator.go(ACTIVATION_ALERTS_ROUTE, {
                ...other,
                webSource: DEFAULT_ACTIVATION_WEB_SOURCE,
                duration,
            }),
        [defaultDuration],
    );

    return { navigateToAlerts };
};
